import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  footer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    height: 72,
    justifyContent: 'flex-end',
    paddingHorizontal: 20,
  },
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: 'rgba(0, 160, 243, 0.05)',
  },
  activeBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    backgroundColor: '#F8F9F9',
  },
  buttonLabelActive: {
    fontSize: 18,
    lineHeight: 24,
    color: '#00A0F3',
    fontWeight: '700',
    marginHorizontal: 24,
    marginVertical: 16,
  },
  buttonLabelNotActive: {
    fontSize: 18,
    lineHeight: 24,
    color: '#CCD6DD',
    fontWeight: '700',
    marginHorizontal: 24,
    marginVertical: 16,
  },
})
